import type { BackstageGatewayApp } from "gateway-backstage";
import { type AppClientOptions, appClient } from "./client";

// Client of the Backstage app (ADR-040): business routes under /api, the login routes at /auth.

export function backstageClient(options: AppClientOptions = {}) {
  const { api, root } = appClient<BackstageGatewayApp>(options);
  return { api, auth: root.auth };
}
